import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'mana-font/css/mana.css';
import {
  Container,
  Heading,
  Text,
  Box,
  Button,
  VStack,
  HStack,
  SimpleGrid,
  Image,
  Icon,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Badge,
} from '@chakra-ui/react';
import {
  FaMagic,
  FaCalendar,
  FaInfoCircle,
  FaUsers,
  FaDice,
  FaCoins,
} from 'react-icons/fa';
import { GiSwordman, GiMagicTrident } from 'react-icons/gi';
import { Link } from 'react-router-dom';
import MagicCalendar from '../components/MagicTheGathering/MagicCalendar';

function MagicTheGathering() {
  const textColor = 'white';
  const accentColor = '#ffcc00';
  const secondaryColor = '#3eb297';

  const [selectedTournament, setSelectedTournament] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const openTournamentModal = (tournament) => {
    setSelectedTournament(tournament);
    onOpen();
  };

  return (
    <Box bg="#36393f" minH="100vh" overflowX="hidden" color="white">
      {/* HERO SECTION - Discord Style */}
      <Box
        position="relative"
        w="100%"
        h={{ base: '400px', md: '500px' }}
        overflow="hidden"
        backgroundImage="linear-gradient(135deg, rgba(255, 204, 0, 0.8) 0%, rgba(62, 178, 151, 0.8) 100%), url('https://cms.cilassociazione.it/uploads/mana_night_7ab01eaf13.jpg')"
        backgroundSize="cover"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
      >
        {/* Overlay leggero per leggibilità testo */}
        <Box
          position="absolute"
          top={0}
          left={0}
          w="100%"
          h="100%"
          bg="rgba(0, 0, 0, 0.4)"
        />
        {/* Contenuto testuale */}
        <Container
          maxW="container.lg"
          height="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          zIndex="2"
          position="relative"
          color="white"
          textAlign="center"
        >
          <VStack spacing={8}>
            <Badge
              bg="#ffcc00"
              color="black"
              px={4}
              py={2}
              borderRadius="full"
              fontSize="sm"
              fontWeight="600"
            >
              🎯 Magic: The Gathering
            </Badge>
            <Icon as={GiMagicTrident} boxSize={20} color="white" />
            <Heading
              as="h1"
              fontSize={{ base: '3xl', md: '5xl' }}
              fontWeight="800"
              color="white"
              letterSpacing="-0.02em"
            >
              Magic: The Gathering
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              maxW="2xl"
              opacity={0.9}
              fontWeight="400"
              px={4}
            >
              Scopri il mondo di Magic: The Gathering, partecipa ai nostri
              eventi e tornei, incontra altri giocatori e immergiti
              nell&apos;universo del gioco di carte più famoso al mondo.
            </Text>
          </VStack>
        </Container>
      </Box>

      {/* MAIN CONTENT */}
      <Container maxW="7xl" py={20}>
        {/* CIL Magic Description and Tools Section */}
        <VStack spacing={16}>
          <VStack spacing={4} textAlign="center">
            <Badge
              bg="#ffcc00"
              color="black"
              px={4}
              py={2}
              borderRadius="full"
              fontSize="sm"
              fontWeight="600"
            >
              🎯 Magic a CIL
            </Badge>
            <Heading as="h2" size="2xl" color="white" fontWeight="800">
              Una Passione Condivisa
            </Heading>
            <Text color="gray.300" fontSize="lg" maxW="3xl" lineHeight="1.7">
              A CIL, Magic: The Gathering non è solo un gioco, ma
              un&apos;esperienza che unisce persone attraverso la strategia, la
              creatività e la competizione amichevole. Il nostro obiettivo è
              rendere l&apos;esperienza di Magic dei soci di CIL più piacevole
              possibile, creando uno spazio dove i giocatori possano crescere
              insieme, condividere conoscenze e partecipare a eventi memorabili.
            </Text>
          </VStack>

          {/* Magic Tools Section */}
          <Box w="100%">
            <VStack spacing={8}>
              <VStack spacing={4} textAlign="center">
                <Badge
                  bg="#ffcc00"
                  color="black"
                  px={4}
                  py={2}
                  borderRadius="full"
                  fontSize="sm"
                  fontWeight="600"
                >
                  <Icon as={FaMagic} mr={2} />
                  Tool Utili
                </Badge>
                <Heading as="h3" size="lg" color="white" fontWeight="700">
                  Strumenti per i Giocatori
                </Heading>
              </VStack>

              <SimpleGrid
                columns={{ base: 1, md: 2 }}
                spacing={6}
                w="100%"
                maxW="800px"
              >
                {/* Scambio Carte Tool */}
                <Button
                  as="a"
                  href="/scambi-carte"
                  bg="#2f3136"
                  color="white"
                  border="2px solid"
                  borderColor="#ffcc00"
                  size="lg"
                  height="80px"
                  leftIcon={<FaMagic />}
                  _hover={{
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(255, 204, 0, 0.3)',
                    bg: '#36393f',
                    borderColor: '#e6b800',
                  }}
                  transition="all 0.3s ease"
                  borderRadius="12px"
                  fontWeight="600"
                >
                  Scambio Carte
                </Button>

                {/* Deck Tool */}
                <Button
                  as="a"
                  href="/decks"
                  bg="#2f3136"
                  color="white"
                  border="2px solid"
                  borderColor={secondaryColor}
                  size="lg"
                  height="80px"
                  leftIcon={<GiMagicTrident />}
                  _hover={{
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 25px rgba(62, 178, 151, 0.3)',
                    bg: '#36393f',
                    borderColor: '#2a9d82',
                  }}
                  transition="all 0.3s ease"
                  borderRadius="12px"
                  fontWeight="600"
                >
                  I Deck dei Soci
                </Button>
              </SimpleGrid>
            </VStack>
          </Box>
        </VStack>
      </Container>

      {/* Tournament Types Section */}
      <Box bg="#2f3136" py={20}>
        <Container maxW="7xl">
          <VStack spacing={16}>
            <VStack spacing={4} textAlign="center">
              <Badge
                bg="#ffcc00"
                color="black"
                px={4}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="600"
              >
                🏆 Tornei
              </Badge>
              <Heading as="h2" size="2xl" color="white" fontWeight="800">
                Tornei di Magic di CIL
              </Heading>
              <Text color="gray.300" fontSize="lg" maxW="2xl">
                Scopri tutti i formati di torneo disponibili e i loro
                regolamenti
              </Text>
            </VStack>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
              {/* Multi Tournament Card */}
              <Box
                bg="#36393f"
                borderRadius="20px"
                overflow="hidden"
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-8px)',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.3s ease"
              >
                <Image
                  src="/images/multi-tournament.jpg"
                  alt="Torneo Multi"
                  height="200px"
                  width="100%"
                  objectFit="cover"
                  fallbackSrc="https://cms.cilassociazione.it/uploads/Multi_0b08cf8fee.png"
                />
                <Box p={6}>
                  <HStack mb={3}>
                    <Icon as={FaUsers} color={accentColor} />
                    <Heading as="h3" size="md" color="white" fontWeight="700">
                      Torneo Multi Commander
                    </Heading>
                  </HStack>
                  <Text color="gray.300" mb={4}>
                    Il campionato CIL Commander! Tornei multi con bracket 3, CIL
                    Points e premi esclusivi. Formato competitivo per veri
                    comandanti.
                  </Text>
                  <VStack spacing={3} w="full">
                    <Button
                      as={Link}
                      to="/magic/cct-regolamento"
                      bg="#ffcc00"
                      color="black"
                      size="sm"
                      w="full"
                      fontWeight="600"
                      _hover={{
                        bg: '#e6b800',
                        transform: 'translateY(-2px)',
                      }}
                      transition="all 0.3s ease"
                    >
                      Regolamento Completo
                    </Button>
                    <Button
                      bg="transparent"
                      color="#ffcc00"
                      border="2px solid"
                      borderColor="#ffcc00"
                      size="sm"
                      onClick={() => openTournamentModal('gamechangers')}
                      w="full"
                      fontWeight="600"
                      _hover={{
                        bg: '#ffcc00',
                        color: 'black',
                        transform: 'translateY(-2px)',
                      }}
                      transition="all 0.3s ease"
                    >
                      Game Changers v1.1
                    </Button>
                  </VStack>
                </Box>
              </Box>

              {/* Duel Tournament Card */}
              <Box
                bg="#36393f"
                borderRadius="20px"
                overflow="hidden"
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-8px)',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.3s ease"
              >
                <Image
                  src="/images/duel-tournament.jpg"
                  alt="Torneo Duel"
                  height="200px"
                  width="100%"
                  objectFit="cover"
                  fallbackSrc="https://cms.cilassociazione.it/uploads/duelmagic_f9ce9f1e6a.jpg"
                />
                <Box p={6}>
                  <HStack mb={3}>
                    <Icon as={GiSwordman} color={secondaryColor} />
                    <Heading as="h3" size="md" color="white" fontWeight="700">
                      Torneo Duel Commander
                    </Heading>
                  </HStack>
                  <Text color="gray.300" mb={4}>
                    Sfide uno contro uno in formato Swiss. Ogni giocatore
                    affronta avversari di livello simile in un torneo
                    equilibrato.
                  </Text>
                  <Button
                    bg="#ffcc00"
                    color="black"
                    size="sm"
                    onClick={() => openTournamentModal('duel')}
                    w="full"
                    fontWeight="600"
                    _hover={{
                      bg: '#e6b800',
                      transform: 'translateY(-2px)',
                    }}
                    transition="all 0.3s ease"
                  >
                    Vedi Regolamenti
                  </Button>
                </Box>
              </Box>

              {/* Draft Tournament Card */}
              <Box
                bg="#36393f"
                borderRadius="20px"
                overflow="hidden"
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-8px)',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.3s ease"
              >
                <Image
                  src="/images/draft-tournament.jpg"
                  alt="Torneo Draft"
                  height="200px"
                  width="100%"
                  objectFit="cover"
                  fallbackSrc="https://cms.cilassociazione.it/uploads/draft_2b020fd20e.jpg"
                />
                <Box p={6}>
                  <HStack mb={3}>
                    <Icon as={FaDice} color="#36a9e1" />
                    <Heading as="h3" size="md" color="white" fontWeight="700">
                      Torneo Draft
                    </Heading>
                  </HStack>
                  <Text color="gray.300" mb={4}>
                    Costruisci il tuo mazzo durante il torneo! Ogni giocatore
                    sceglie carte da booster pack per creare strategie uniche.
                  </Text>
                  <Button
                    bg="#ffcc00"
                    color="black"
                    size="sm"
                    onClick={() => openTournamentModal('draft')}
                    w="full"
                    fontWeight="600"
                    _hover={{
                      bg: '#e6b800',
                      transform: 'translateY(-2px)',
                    }}
                    transition="all 0.3s ease"
                  >
                    Vedi Regolamenti
                  </Button>
                </Box>
              </Box>

              {/* Pauper Tournament Card */}
              <Box
                bg="#36393f"
                borderRadius="20px"
                overflow="hidden"
                border="1px solid"
                borderColor="gray.600"
                _hover={{
                  transform: 'translateY(-8px)',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                  borderColor: '#ffcc00',
                }}
                transition="all 0.3s ease"
              >
                <Image
                  src="/images/pauper-tournament.jpg"
                  alt="Torneo Pauper"
                  height="200px"
                  width="100%"
                  objectFit="cover"
                  fallbackSrc="https://cms.cilassociazione.it/uploads/pauper_25deb5b726.jpeg"
                />
                <Box p={6}>
                  <HStack mb={3}>
                    <Icon as={FaCoins} color="#e95995" />
                    <Heading as="h3" size="md" color="white" fontWeight="700">
                      Torneo Pauper
                    </Heading>
                  </HStack>
                  <Text color="gray.300" mb={4}>
                    Tornei con solo carte comuni! Costruisci mazzi potenti
                    utilizzando esclusivamente carte di rarità comune, rendendo
                    il gioco accessibile a tutti.
                  </Text>
                  <Button
                    bg="#ffcc00"
                    color="black"
                    size="sm"
                    onClick={() => openTournamentModal('pauper')}
                    w="full"
                    fontWeight="600"
                    _hover={{
                      bg: '#e6b800',
                      transform: 'translateY(-2px)',
                    }}
                    transition="all 0.3s ease"
                  >
                    Vedi Regolamenti
                  </Button>
                </Box>
              </Box>
            </SimpleGrid>
          </VStack>
        </Container>
      </Box>

      {/* Calendario Eventi */}
      <Container maxW="7xl" py={20}>
        <VStack spacing={8}>
          <VStack spacing={4} textAlign="center">
            <Badge
              bg="#ffcc00"
              color="black"
              px={4}
              py={2}
              borderRadius="full"
              fontSize="sm"
              fontWeight="600"
            >
              📅 Calendario
            </Badge>
            <Heading as="h2" size="2xl" color="white" fontWeight="800">
              Eventi Magic
            </Heading>
            <Text color="gray.300" fontSize="lg" maxW="2xl">
              Scopri tutti gli eventi Magic in programma
            </Text>
          </VStack>

          <Box w="100%">
            <MagicCalendar />
          </Box>
        </VStack>
      </Container>

      {/* Contact Section */}
      <Box bg="#2f3136" py={20}>
        <Container maxW="7xl">
          <VStack spacing={12}>
            <VStack spacing={4} textAlign="center">
              <Badge
                bg="#ffcc00"
                color="black"
                px={4}
                py={2}
                borderRadius="full"
                fontSize="sm"
                fontWeight="600"
              >
                💬 Contatti
              </Badge>
              <Heading as="h2" size="2xl" color="white" fontWeight="800">
                Hai domande su Magic: The Gathering?
              </Heading>
              <Text color="gray.300" fontSize="lg" maxW="2xl">
                Contattaci per informazioni sui nostri eventi, tornei e sessioni
                di gioco.
              </Text>
            </VStack>

            <HStack spacing={6} justify="center" flexWrap="wrap">
              <Button
                bg="#ffcc00"
                color="black"
                size="lg"
                px={8}
                py={6}
                borderRadius="12px"
                fontWeight="700"
                fontSize="lg"
                leftIcon={<FaMagic />}
                onClick={() => {
                  window.location.href = 'mailto:info@cil.it';
                }}
                _hover={{
                  bg: '#e6b800',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(255, 204, 0, 0.4)',
                }}
                transition="all 0.3s ease"
              >
                Contattaci
              </Button>
              <Button
                bg="transparent"
                color="#ffcc00"
                border="2px solid"
                borderColor="#ffcc00"
                size="lg"
                px={8}
                py={6}
                borderRadius="12px"
                fontWeight="700"
                fontSize="lg"
                leftIcon={<FaCalendar />}
                onClick={() => {
                  window.location.href = '/eventi';
                }}
                _hover={{
                  bg: '#ffcc00',
                  color: 'black',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 25px rgba(255, 204, 0, 0.4)',
                }}
                transition="all 0.3s ease"
              >
                Vedi Tutti gli Eventi
              </Button>
            </HStack>
          </VStack>
        </Container>
      </Box>

      {/* Tournament Rules Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent bg="#36393f" color="white">
          <ModalHeader>
            <HStack>
              <Icon as={FaInfoCircle} color={accentColor} />
              <Text>
                {selectedTournament === 'multi' &&
                  'CCT - CIL Commander Tournament'}
                {selectedTournament === 'duel' && 'Regolamenti Duel Torneo'}
                {selectedTournament === 'draft' && 'Regolamenti Draft Torneo'}
                {selectedTournament === 'pauper' && 'Regolamenti Torneo Pauper'}
                {selectedTournament === 'gamechangers' &&
                  'Game Changers v1.1 - Lista Carte'}
              </Text>
            </HStack>
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>
            {selectedTournament === 'multi' && (
              <VStack spacing={6} align="stretch">
                <Box textAlign="center" py={8}>
                  <Icon as={FaMagic} boxSize={16} color={accentColor} mb={4} />
                  <Heading as="h3" size="lg" color={textColor} mb={4}>
                    🏆 CCT - CIL Commander Tournament
                  </Heading>
                  <Text color="gray.600" fontSize="lg" mb={6}>
                    I regolamenti dettagliati del nostro campionato Commander
                    sono in fase di finalizzazione.
                  </Text>
                  <Text color="gray.500" fontSize="md">
                    <strong>Coming Soon!</strong> Stiamo lavorando per rendere
                    l&apos;esperienza di gioco ancora più coinvolgente e
                    organizzata.
                  </Text>
                </Box>
              </VStack>
            )}

            {selectedTournament === 'duel' && (
              <VStack spacing={6} align="stretch">
                <Box textAlign="center" py={8}>
                  <Icon
                    as={GiSwordman}
                    boxSize={16}
                    color={secondaryColor}
                    mb={4}
                  />
                  <Heading as="h3" size="lg" color={textColor} mb={4}>
                    ⚔️ Duel Torneo
                  </Heading>
                  <Text color="gray.600" fontSize="lg" mb={6}>
                    I regolamenti dettagliati del nostro torneo Duel sono in
                    fase di finalizzazione.
                  </Text>
                  <Text color="gray.500" fontSize="md">
                    <strong>Coming Soon!</strong> Stiamo lavorando per rendere
                    l&apos;esperienza di gioco ancora più coinvolgente e
                    organizzata.
                  </Text>
                </Box>
              </VStack>
            )}

            {selectedTournament === 'draft' && (
              <VStack spacing={6} align="stretch">
                <Box textAlign="center" py={8}>
                  <Icon as={FaDice} boxSize={16} color={accentColor} mb={4} />
                  <Heading as="h3" size="lg" color={textColor} mb={4}>
                    🎲 Draft Torneo
                  </Heading>
                  <Text color="gray.600" fontSize="lg" mb={6}>
                    I regolamenti dettagliati del nostro torneo Draft sono in
                    fase di finalizzazione.
                  </Text>
                  <Text color="gray.500" fontSize="md">
                    <strong>Coming Soon!</strong> Stiamo lavorando per rendere
                    l&apos;esperienza di gioco ancora più coinvolgente e
                    organizzata.
                  </Text>
                </Box>
              </VStack>
            )}

            {selectedTournament === 'pauper' && (
              <VStack spacing={6} align="stretch">
                <Box textAlign="center" py={8}>
                  <Icon as={FaCoins} boxSize={16} color="#e95995" mb={4} />
                  <Heading as="h3" size="lg" color={textColor} mb={4}>
                    🪙 Torneo Pauper
                  </Heading>
                  <Text color="gray.600" fontSize="lg" mb={6}>
                    I regolamenti dettagliati del nostro torneo Pauper sono in
                    fase di finalizzazione.
                  </Text>
                  <Text color="gray.500" fontSize="md">
                    <strong>Coming Soon!</strong> Stiamo lavorando per rendere
                    l&apos;esperienza di gioco ancora più coinvolgente e
                    organizzata.
                  </Text>
                </Box>
              </VStack>
            )}

            {selectedTournament === 'gamechangers' && (
              <VStack spacing={6} align="stretch">
                {/* Header */}
                <Box textAlign="center">
                  <Heading as="h3" size="lg" mb={2} color={textColor}>
                    🎯 Game Changers v1.1
                  </Heading>
                  <Text color="gray.600" mb={1}>
                    <strong>Massimo 3 carte totali per deck</strong>
                  </Text>
                  <Text color="gray.600" fontSize="sm">
                    ⚠️ Se una carta è nella banlist Commander RC, resta vietata
                    comunque
                  </Text>
                </Box>

                {/* White Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>White</Text>
                      <i
                        className="ms ms-w"
                        style={{ fontSize: '20px', color: '#f8f6d7' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Drannith Magistrate</Text>
                    <Text color="gray.600">• Enlightened Tutor</Text>
                    <Text color="gray.600">• Humility</Text>
                    <Text color="gray.600">• Serra&apos;s Sanctum</Text>
                    <Text color="gray.600">• Smothering Tithe</Text>
                    <Text color="gray.600">• Teferi&apos;s Protection</Text>
                  </SimpleGrid>
                </Box>

                {/* Blue Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Blue</Text>
                      <i
                        className="ms ms-u"
                        style={{ fontSize: '20px', color: '#0e68ab' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Consecrated Sphinx</Text>
                    <Text color="gray.600">• Cyclonic Rift</Text>
                    <Text color="gray.600">• Expropriate</Text>
                    <Text color="gray.600">• Force of Will</Text>
                    <Text color="gray.600">• Fierce Guardianship</Text>
                    <Text color="gray.600">• Gifts Ungiven</Text>
                    <Text color="gray.600">• Intuition</Text>
                    <Text color="gray.600">• Jin-Gitaxias, Core Augur</Text>
                    <Text color="gray.600">• Mystical Tutor</Text>
                    <Text color="gray.600">• Narset, Parter of Veils</Text>
                    <Text color="gray.600">• Rhystic Study</Text>
                    <Text color="gray.600">• Sway of the Stars</Text>
                    <Text color="gray.600">• Thassa&apos;s Oracle</Text>
                    <Text color="gray.600">• Urza, Lord High Artificer</Text>
                  </SimpleGrid>
                </Box>

                {/* Black Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Black</Text>
                      <i
                        className="ms ms-b"
                        style={{ fontSize: '20px', color: '#150b00' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Bolas&apos;s Citadel</Text>
                    <Text color="gray.600">• Braids, Cabal Minion</Text>
                    <Text color="gray.600">• Demonic Tutor</Text>
                    <Text color="gray.600">• Imperial Seal</Text>
                    <Text color="gray.600">• Necropotence</Text>
                    <Text color="gray.600">• Opposition Agent</Text>
                    <Text color="gray.600">• Orcish Bowmasters</Text>
                    <Text color="gray.600">• Tergrid, God of Fright</Text>
                    <Text color="gray.600">• Vampiric Tutor</Text>
                    <Text color="gray.600">• Ad Nauseam</Text>
                  </SimpleGrid>
                </Box>

                {/* Red Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Red</Text>
                      <i
                        className="ms ms-r"
                        style={{ fontSize: '20px', color: '#d3202a' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Deflecting Swat</Text>
                    <Text color="gray.600">• Gamble</Text>
                    <Text color="gray.600">• Jeska&apos;s Will</Text>
                    <Text color="gray.600">• Underworld Breach</Text>
                  </SimpleGrid>
                </Box>

                {/* Green Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Green</Text>
                      <i
                        className="ms ms-g"
                        style={{ fontSize: '20px', color: '#00733e' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Crop Rotation</Text>
                    <Text color="gray.600">• Food Chain</Text>
                    <Text color="gray.600">• Gaea&apos;s Cradle</Text>
                    <Text color="gray.600">• Natural Order</Text>
                    <Text color="gray.600">• Seedborn Muse</Text>
                    <Text color="gray.600">• Survival of the Fittest</Text>
                    <Text color="gray.600">• Vorinclex, Voice of Hunger</Text>
                    <Text color="gray.600">• Worldly Tutor</Text>
                  </SimpleGrid>
                </Box>

                {/* Multicolored Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Multicolored</Text>
                      <i
                        className="ms ms-1"
                        style={{ fontSize: '20px', color: '#a3a3a3' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Aura Shards</Text>
                    <Text color="gray.600">• Coalition Victory</Text>
                    <Text color="gray.600">• Grand Arbiter Augustin IV</Text>
                    <Text color="gray.600">• Kinnan, Bonder Prodigy</Text>
                    <Text color="gray.600">
                      • Yuriko, the Tiger&apos;s Shadow
                    </Text>
                    <Text color="gray.600">• Notion Thief</Text>
                    <Text color="gray.600">• Winota, Joiner of Forces</Text>
                  </SimpleGrid>
                </Box>

                {/* Colorless Cards */}
                <Box>
                  <Heading as="h4" size="md" mb={3} color={textColor}>
                    <HStack spacing={2}>
                      <Text>Colorless</Text>
                      <i
                        className="ms ms-1"
                        style={{ fontSize: '20px', color: '#a3a3a3' }}
                      />
                    </HStack>
                  </Heading>
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={2}>
                    <Text color="gray.600">• Ancient Tomb</Text>
                    <Text color="gray.600">• Chrome Mox</Text>
                    <Text color="gray.600">• Field of the Dead</Text>
                    <Text color="gray.600">• Glacial Chasm</Text>
                    <Text color="gray.600">• Grim Monolith</Text>
                    <Text color="gray.600">• Lion&apos;s Eye Diamond</Text>
                    <Text color="gray.600">• Mana Vault</Text>
                    <Text color="gray.600">• Mishra&apos;s Workshop</Text>
                    <Text color="gray.600">• Mox Diamond</Text>
                    <Text color="gray.600">• Panoptic Mirror</Text>
                    <Text color="gray.600">• The One Ring</Text>
                    <Text color="gray.600">
                      • The Tabernacle at Pendrell Vale
                    </Text>
                  </SimpleGrid>
                </Box>

                {/* Warning */}
                <Box
                  bg="yellow.50"
                  p={4}
                  borderRadius="md"
                  border="1px solid"
                  borderColor="yellow.200"
                >
                  <Text color="yellow.800" fontSize="sm" textAlign="center">
                    <strong>⚠️ ATTENZIONE:</strong> Superare il limite di 3
                    carte Game Changers comporta -8 punti e rimozione immediata
                    delle eccedenze!
                  </Text>
                </Box>
              </VStack>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={onClose}
              bg="#2f3136"
              color="white"
              border="1px solid"
              borderColor="gray.600"
              _hover={{
                bg: '#36393f',
                borderColor: '#ffcc00',
              }}
              transition="all 0.3s ease"
            >
              Chiudi
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default MagicTheGathering;
